import React from "react";
import SvgIcon from "../parts/SvgIcon";

function View(props, { locals }) {
  return (
    <div id="error-wrapper">
      <SvgIcon
        src={"/img/new-icons/msb-logo-not-extended.svg"}
        noFilterOnLight={true}
      />
      <h1 className="alt">Page Not Found</h1>
      <p className="p2">The page you're looking for does not exist.</p>
      <button data-button-type="primary" onClick={() => history.back()}>
        Go Back
      </button>
    </div>
  );
}

const NotFound = (app) => {
  app.get("/404", ({ res }) => (res.body = <View />));
};

export default NotFound;
